import { render, staticRenderFns } from "./updatePartnerSummaryCp.vue?vue&type=template&id=3212984e&scoped=true"
import script from "./updatePartnerSummaryCp.vue?vue&type=script&lang=js"
export * from "./updatePartnerSummaryCp.vue?vue&type=script&lang=js"
import style0 from "./updatePartnerSummaryCp.vue?vue&type=style&index=0&id=3212984e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3212984e",
  null
  
)

export default component.exports